import { render, staticRenderFns } from "./TermsOfServicesView.vue?vue&type=template&id=b30b5c38"
import script from "./TermsOfServicesView.vue?vue&type=script&lang=js"
export * from "./TermsOfServicesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports